import { useEffect } from 'react';

function useKeyboard(bindings, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;

    const handler = (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) return;
      const callback = bindings[event.key.toLowerCase()];
      if (callback) {
        event.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [bindings, enabled]);
}

export default useKeyboard;